import { render } from "./OutcomeEventDialog.vue?vue&type=template&id=24952a46&ts=true"
import script from "./OutcomeEventDialog.vue?vue&type=script&lang=ts"
export * from "./OutcomeEventDialog.vue?vue&type=script&lang=ts"

import exportComponent from "D:\\a\\1\\s\\cst\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__